import React, { memo } from 'react';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
}

const ConfirmModalComponent: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-lg p-4 md:p-6 max-w-md w-full">
        <h3 className="text-base md:text-lg font-semibold mb-2">{title}</h3>
        <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6">{message}</p>
        <div className="flex justify-end gap-2 md:gap-4">
          <button
            onClick={onClose}
            className="px-3 md:px-4 py-1.5 md:py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition-colors text-sm md:text-base"
          >
            취소
          </button>
          <button
            onClick={onConfirm}
            className="px-3 md:px-4 py-1.5 md:py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors text-sm md:text-base"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export const ConfirmModal = memo(ConfirmModalComponent);
